

import { defineComponent } from "vue";
import { mapStores } from "pinia";
import { NForm, NFormItem, NInput, NButton } from "naive-ui";
import BasePage from '~/core/base-page';

import { useStationStore } from "../store/station.store";
import { NavigationFailure } from "vue-router";
import { Station } from "~/api/models/station.model";


export default defineComponent({

    extends: BasePage,

    components: {
        NInput,
        NButton,
        NForm,
        NFormItem,
    },

    data() {
        const result = { pairingToken: ''};
        return {
            valid: false,
            pristine: true,
            result,
            rules: {
                pairingToken: {
                    required: true,
                }
            }
        }
    },

    async mounted(): Promise<void> {

    },

    computed: {
        ...mapStores(useStationStore),
    },

    methods: {
        submit(event: Event): Promise<void | NavigationFailure> {
            event.preventDefault();

            if(!this.valid) {
                console.warn('form is invalid', this.result);
                return;
            }
            
            return this.addStation(this.result.pairingToken)
                .then((station: Station) => this.$router.push({ name: 'dashboard', params: { station: station.id }}));
        },

        async addStation(pairingToken: string): Promise<Station> {
            try {
                return await this.stationStore.pairStation(pairingToken);
            } catch(error) {
                if(error.response.status === 404) {
                    this.notification('error', this.$t('add_station.station_not_found_title'), this.$t('add_station.station_with_pairing_token_does_not_exist', {pairing_token: pairingToken}))
                } else {
                    this.showUnhandledError('Could not add station', error);
                }
            }
        }
    },

    watch: {
        result: {
            handler(to, from) {

                this.pristine = false;
                //@ts-ignore
                this.$refs?.AddStationForm?.validate((errors) => {
                    if (errors) {
                        console.error(errors);
                        this.valid = false;
                        return;
                    }

                    this.valid = true;
                });
            },
            deep: true,
        }
    }
})

